<template>
  <div id="participants">
    <div class="main">
      <MeetingParticipants :_id="$route.params.id" />
    </div>
  </div>
</template>

<script>
import MeetingParticipants from "@/components/MeetingParticipants";
import Admin from "../../../mixin/guard/admin";
export default {
  mixins: [Admin],
  components: { MeetingParticipants },
};
</script>

<style></style>
../../../mixin/guard/admin
